import React, {createContext, ReactNode} from 'react';

import {COACH} from '/enum/competency.enum';
import competencies from '/theme/competency';

interface ThemeContextType {
  competency: string;
}

interface ThemeProviderProps {
  currentUserCompetency: string;
  children: ReactNode;
}

export const ThemeContext = createContext<ThemeContextType | undefined>(
  undefined,
);

const ThemeProvider = ({
  currentUserCompetency = COACH,
  children = null,
}: ThemeProviderProps) => {
  return (
    <ThemeContext.Provider
      value={{
        competency: competencies[currentUserCompetency],
      }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;
